export const CLASS_ACTIVE = 'is-active';
export const CLASS_OPEN = 'is-open';
// export const CLASS_CLOSED = 'is-closed';
export const CLASS_HIDDEN = 'is-hidden';
export const CLASS_VISIBLE = 'is-visible';
// export const CLASS_FADE_IN = 'is-fade-in';
// export const CLASS_FADE_OUT = 'is-fade-out';
export const CLASS_STICKY = 'is-sticky';
export const CLASS_SCROLLING = 'is-scrolling';
// export const CLASS_FIXED = 'is-fixed';
// export const CLASS_UNAVAILABLE = 'is-unavailable';
export const CLASS_SELECTED = 'is-selected';
export const CLASS_DISABLED = 'is-disabled';
export const CLASS_SCROLL_DISABLED = 'is-scroll-disabled';
// export const CLASS_HAS_ERROR = 'has-error';
export const CLASS_MENU_OPEN = 'is-menu-open';
export const CLASS_HAS_ERROR = 'has-error';
// export const CLASS_MENU_TOGGLE = 'is-menu-open';
export const CLASS_INITIALISED = 'is-initialised';
export const CLASS_WISHLIST_INITIALISED = 'is-wishlist-initialised';
export const CLASS_THUMB_INITIALISED = 'is-thumbnail-initialised';
// export const CLASS_PENDING = 'is-pending';
export const CLASS_FILTERED = 'is-filtered';
export const CLASS_FILTERING = 'is-filtering';
export const CLASS_EXPANDED = 'is-expanded';
export const CLASS_LOADING = 'is-loading';
export const CLASS_LOADED = 'is-loaded';
// export const CLASS_CART_PENDING = 'is-cart-pending';
export const CLASS_HEADER_STICKY = 'is-header-sticky';
export const CLASS_IS_INVERTED = 'is-inverted';
export const CLASS_DRAWER_OPEN = 'is-drawer-open';
export const CLASS_MENU_HOVER = 'is-menu-hover';
export const CLASS_SEARCH_OPEN = 'is-search-open';
export const CLASS_CART_PENDING = 'is-cart-pending';
export const CLASS_HAS_FIXED_HEADER = 'has-fixed-header';
export const CLASS_HAS_ITEMS = 'has-items';
export const CLASS_MUTED = 'is-muted';
export const CLASS_OVERFLOW = 'is-overflow';
export const CLASS_IS_MENU_ITEM_HOVER = 'is-menu-item-hover';
export const CLASS_SOLD_OUT = 'is-sold-out';
export const CLASS_LOW_STOCK = 'low-stock';
export const CLASS_ALLOW_SCROLL = 'allow-scroll';
export const CLASS_MOBILE_MENU_OPEN = 'is-mobile-open';
export const CLASS_VIDEO_ACTIVE = 'is-video-active';
export const CLASS_COLOR = 'is-color';
